import {Add, Remove} from '@mui/icons-material'
import { Icon } from '@mui/material'

export const ExpandedIcon = ({name, expanded}: {
    name: string,
    expanded: boolean,
}) => {
    return (
        <Icon className="accordion-expanded-icon icon-button"
                    data-testid={`expanded-icon-${name}`}>
            {expanded ? <Remove/> : <Add/>}
        </Icon>
    )
}